export default __webpack_public_path__ + "static/media/634.980c026e.png";